import { ChangeDetectionStrategy, Component } from '@angular/core';
import { take } from 'rxjs';
import { RouterService } from 'src/app/libs/data-access/services/router/router.service';
import { PagesRoute } from 'src/app/pages/src/app/ui/routes/routes.enum';
import { PaymentFacade } from '../../../data-access/services/payment.facade';
import { PaymentPageRoutes } from '../../routes/routes.enum';

@Component({
  selector: 'tic-order-summery-page',
  templateUrl: './order-summery-page.component.html',
  styleUrls: ['./order-summery-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSummeryPageComponent {
  showFiller = false;
  panelOpenState = false;
  showFlightDetails: boolean = false;
  showHotelDetails: boolean = false;
  
  constructor(
    private routerService: RouterService,
    public facade: PaymentFacade,
  ) {
    const { data } = this.routerService.getUrlStateData() as any || {}; //TODO: complete type
    if (data) {     
      const { flightOfferId, flightOfferPrice } = data; 
      this.loadFlightOffer(flightOfferId);
      this.facade.flightOffer$.pipe(take(1)).subscribe(data => {
        this.routerService.navigateAndAddHiddenParamsToUrl({}, false, `${PagesRoute.PaymentPage}/${PaymentPageRoutes.Checkout}`); 
      });
    } else {
      this.routerService.navigate(PagesRoute.HomePage);
    }
  }

  loadFlightOffer(flightOfferId: string): void { //TODO: complete type
    this.facade.loadFlightOffer(flightOfferId);
  };

  toggleFlightDetails() {
    this.showFlightDetails = !this.showFlightDetails;
  }

  toggleHotelDetails() {
    this.showHotelDetails = !this.showHotelDetails;
  }
}
